const ajaxLoadMoreProducts = () => {
  let canBeLoaded = true
  const bottomOffset = 200

  $(window).scroll(function () {
    var data = {
      'action': 'loadmore_products',
      'query': loadMoreProducts.posts,
      'page' : loadMoreProducts.current_page
    }

    if (
      $(window).scrollTop() + $(window).height() >=
        $(document).height() - bottomOffset &&
      canBeLoaded === true
    ) {
      $.ajax({
        url: loadMoreProducts.ajaxurl,
        data: data,
        type: 'POST',
        beforeSend: function (xhr) {
          canBeLoaded = false
          if (loadMoreProducts.current_page < loadMoreProducts.max_page) {
            $('#loadmore-products-scroll').removeClass('opacity-0')
            $('#loadmore-products-scroll').addClass('opacity-100')
          }
        },
        success: function (data) {
          if (data) {
            $('.product-list')
            .find('.product-card:last-child')
            .after(data)

            loadMoreProducts.current_page++
            canBeLoaded = true
            $('#loadmore-products-scroll').removeClass('opacity-100').delay(2000).addClass('opacity-0')
          }
        }
      })
    }
  })
}

export default ajaxLoadMoreProducts
